import { useGetAccountUsers } from '@cocoonspace/sdk-js/domains/account/account'
import { Button } from '@cocoonspace/ui/components/button'
import { Card } from '@cocoonspace/ui/components/card'
import { useLingui } from '@lingui/react/macro'
import { ArrowRightIcon } from 'lucide-react'
import { LocalizedLink as Link } from '~/components/localized-link'

import { useUserContext } from '~/providers/user-provider'

export const UsersMgmt = () => {
	const { t } = useLingui()
	const { userQuery, isBusiness } = useUserContext()

	const user = userQuery.data
	const canManageUsers = user?.permissions?.user_management_write

	const shouldShow = isBusiness && canManageUsers

	const { data: usersCount } = useGetAccountUsers({
		query: {
			enabled: shouldShow,
			select: ({ data }) =>
				data.filter((user) => user.status === 'enabled').length,
		},
	})

	if (!shouldShow) return null

	return (
		<Card className='flex flex-col gap-2 p-4'>
			<div className='font-bold'>{t`Mes collaborateurs`}</div>

			<div className='text-primary flex flex-1 items-center justify-center text-center text-2xl font-bold'>
				{usersCount ?? 0}
			</div>

			<Button
				variant='link'
				size='sm'
				className='ml-auto gap-1'
				asChild
			>
				<Link href='/account/users-management'>
					{t`Gérer les membres`}
					<ArrowRightIcon className='!size-3' />
				</Link>
			</Button>
		</Card>
	)
}
